export interface ConsoleRequestDiagnostic {
  clientRequestId: string;
  operation: "alignment_fields_or_count" | "alignment_start" | "execution_history" | "execution_detail" | "execution_command" | "console_api";
  method: string;
  phase: "csrf" | "request" | "response";
  startedAt: string;
  durationMs: number;
  status: number | null;
  errorClass: string;
}

export function consoleRequestOperation(path: string): ConsoleRequestDiagnostic["operation"] {
  const pathname = path.split("?")[0];
  if (/^\/kintone-apps\/[^/]+\/attachment-storage-alignment-plan-preview$/u.test(pathname)) return "alignment_fields_or_count";
  if (/^\/kintone-apps\/[^/]+\/attachment-storage-alignment-executions$/u.test(pathname)) return "alignment_start";
  if (pathname === "/asynchronous-executions") return "execution_history";
  if (/^\/asynchronous-executions\/[^/]+$/u.test(pathname)) return "execution_detail";
  if (/^\/kintone-apps\/[^/]+\/[^/]+-executions\/[^/]+\/(cancel|resume)$/u.test(pathname)) return "execution_command";
  return "console_api";
}

export function recordConsoleRequestFailure(diagnostic: ConsoleRequestDiagnostic) {
  // Only closed operation names and transport metadata; no URL, body or headers.
  console.error("[console-api] request failed", diagnostic);
  try {
    const key = "kdrive.console.request-failures";
    const prior: unknown = JSON.parse(sessionStorage.getItem(key) ?? "[]");
    sessionStorage.setItem(key, JSON.stringify([
      ...(Array.isArray(prior) ? prior.slice(-19) : []), diagnostic,
    ]));
  } catch {
    // Browser console remains available when session storage is disabled/full.
  }
}
